import React, { useState } from "react";
import { Link } from "react-router-dom";
import MainLogo from "../brand/MainLogo";
import { COLORS, PILLARS, BRAND_TAGLINE, SITE } from "../brand/tokens";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteFooter = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) return;
    setBusy(true);
    try {
      const res = await axios.post(`${API}/subscribe`, { email, source: "footer" });
      setStatus(res.data.already_subscribed ? "already" : "ok");
      setEmail("");
    } catch (err) {
      setStatus("error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="site-footer__grid">
        <div className="site-footer__brand">
          <MainLogo size={100} />
          <p className="site-footer__tagline">{BRAND_TAGLINE}.</p>
          <p className="site-footer__pillars">{PILLARS}</p>
        </div>

        <div className="site-footer__col">
          <h5>Explore</h5>
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/walk">The Rona Walk</Link>
          <Link to="/shop">Shop</Link>
          <Link to="/journal">Journal</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="site-footer__col">
          <h5>Shop</h5>
          <a href={SITE.shops.etsy} target="_blank" rel="noreferrer">Etsy</a>
          <a href={SITE.shops.tapstitch} target="_blank" rel="noreferrer">Tapstitch</a>
        </div>

        <div className="site-footer__col">
          <h5>Follow</h5>
          <a href={SITE.socials.instagram} target="_blank" rel="noreferrer">Instagram</a>
          <a href={SITE.socials.tiktok} target="_blank" rel="noreferrer">TikTok</a>
          <a href={SITE.socials.youtube} target="_blank" rel="noreferrer">YouTube</a>
          <a href={SITE.socials.pinterest} target="_blank" rel="noreferrer">Pinterest</a>
          <a href={SITE.socials.linkedin} target="_blank" rel="noreferrer">LinkedIn</a>
        </div>

        <div className="site-footer__signup">
          <h5>Take one gentle step.</h5>
          <p>Join our walk. Monthly reflections, seasonal walks, gentle wellness.</p>
          <form onSubmit={submit} data-testid="footer-subscribe-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              data-testid="footer-subscribe-input"
            />
            <button type="submit" disabled={busy} data-testid="footer-subscribe-btn">
              {busy ? "…" : "Join"}
            </button>
          </form>
          {status === "ok" && <p className="site-footer__msg site-footer__msg--ok">Welcome 🌿</p>}
          {status === "already" && <p className="site-footer__msg">You're already on the walk 🌿</p>}
          {status === "error" && <p className="site-footer__msg site-footer__msg--err">Something went wrong. Please try again.</p>}
        </div>
      </div>

      <div className="site-footer__bottom">
        <span>© {new Date().getFullYear()} Rona Wellness</span>
        <span>{SITE.email}</span>
        <Link to="/impressum" data-testid="footer-impressum-link">Impressum</Link>
        <Link to="/brand" data-testid="footer-brand-link">Brand kit</Link>
      </div>
    </footer>
  );
};

export default SiteFooter;
